/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_TitleInputs */

const en_byoa_title = /** @type {(inputs: Byoa_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My AI connections`)
};

const id_byoa_title = /** @type {(inputs: Byoa_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koneksi AI-ku`)
};

/**
* | output |
* | --- |
* | "My AI connections" |
*
* @param {Byoa_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_title = /** @type {((inputs?: Byoa_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_title(inputs)
	return en_byoa_title(inputs)
});